import { ReactNode, useEffect } from "react";
import { getEcho, useEchoStore } from "@/shared/lib/echo-client";

type Props = {
  children: ReactNode;
};

export const EchoProvider = ({ children }: Props) => {
  const echo = useEchoStore((state) => state.echo);

  useEffect(() => {
    if (!echo) {
      getEcho();
    }

    return () => {
      echo?.disconnect();
    };
  }, [echo]);

  return children;
};
